import React from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { BsFillPersonBadgeFill } from "react-icons/bs";
import RuleIcon from "@mui/icons-material/Rule";
import MaterialBox from "../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialButton from "../../../components/MaterialButton";
import { useState } from "react";
import MaterialInput from "../../../components/MaterialInput";
const ShippingMethodOption = [
  {
    id: 1,
    value: "Standard Shipping",
  },
  {
    id: 2,
    value: "Expedited Shipping",
  },
  {
    id: 3,
    value: "Express Shipping ",
  },
  {
    id: 4,
    value: "Same Day or Next Day Shipping",
  },
  {
    id: 5,
    value: "Free Shipping",
  },
  {
    id: 6,
    value: "International Shipping",
  },
  {
    id: 6,
    value: "In Store Pickup Shipping",
  },
];

const Payment = [
  {
    id: 1,
    status: "Payment 30 days after invoice date",
  },
  {
    id: 2,
    status: "Payment 7 days after invoice date",
  },
  {
    id: 3,
    status: "payment in advance",
  },
  {
    id: 4,
    status: "immediate payment",
  },
  {
    id: 5,
    status: "Payment 45 days after invoice date",
  },
  {
    id: 6,
    status: " Payment 10 days after invoice date",
  },
];
const Convertsalesorder = () => {
  const [statusOption, setStatusOption] = useState([]);
  const [statusData, setStatusData] = useState({
    // Brand Details
    status: "",
    reason: "",
    closedDate: "",
    paymentTerms: "",

    // Brand Type Status
    statusStatus: "unchecked",
    reasonStatus: "unchecked",
    closedDateStatus: "unchecked",
    paymentTermsStatus: "unchecked",
  });

  const handleChange = (event, selectEvent) => {
    let statusState = { ...statusData };
    const changeAllowed = true;
    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "paymentTerms":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              statusState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
              statusState["reason"] = "";
              statusState["reasonStatus"] = "unchecked";
            } else {
              statusState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
              setStatusOption([]);
              statusState["reason"] = "";
              statusState["reasonStatus"] = "unchecked";
            }
          }
          break;
        case "reason":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              statusState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              statusState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      statusState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "closedDate":
          {
            const alphaNLenghthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              statusState[event.target.name + "Status"] = "success";
            } else {
              statusState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        statusState[event.target.name] = event.target.value;
      }
    }
    setStatusData(statusState);
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Change Won / Loss
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "90vh" }}>
          <Stack direction="row" spacing={1}>
            <RuleIcon style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Change Won / Loss (QuoteId)
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Convert po Number <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="closedDate"
                  type="text"
                  placeholder="eg. 01-01-2024"
                  value={statusData.closedDate}
                  onChange={handleChange}
                  error={statusData.closedDateStatus === "error" ? true : false}
                  success={
                    statusData.closedDateStatus === "success" ? true : false
                  }
                />
                {statusData.closedDateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Date Of Registration
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    sale order Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="closedDate"
                  type="date"
                  placeholder="eg. 01-01-2024"
                  value={statusData.closedDate}
                  onChange={handleChange}
                  error={statusData.closedDateStatus === "error" ? true : false}
                  success={
                    statusData.closedDateStatus === "success" ? true : false
                  }
                />
                {statusData.closedDateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Date Of Registration
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Delivery Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="closedDate"
                  type="date"
                  placeholder="eg. 01-01-2024"
                  value={statusData.closedDate}
                  onChange={handleChange}
                  error={statusData.closedDateStatus === "error" ? true : false}
                  success={
                    statusData.closedDateStatus === "success" ? true : false
                  }
                />
                {statusData.closedDateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Date Of Registration
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
            <Grid size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Payment Terms <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="paymentTerms"
                value={statusData.status}
                //   defaultValue={{ label: "Please select" }}
                //   customStyles={{ optionPadding: 20 }}
                onChange={handleChange} //selectedValue, event
                options={Payment.map((value) => {
                  return {
                    value: value.id,
                    label: value.status,
                  };
                })}
                error={statusData.paymentTermsStatus === "error" ? true : false}
                success={
                  statusData.paymentTermsStatus === "success" ? true : false
                }
                isClearable
              />
            </Grid>
            <Grid size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Reason <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="reason"
                value={statusData.reason}
                //   defaultValue={{ label: "Please select" }}
                //   customStyles={{ optionPadding: 20 }}
                onChange={handleChange} //selectedValue, event
                options={ShippingMethodOption.map((value) => {
                  return {
                    value: value.id,
                    label: value.value,
                  };
                })}
                error={statusData.reasonStatus === "error" ? true : false}
                success={statusData.reasonStatus === "success" ? true : false}
                isClearable
              />
            </Grid>
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              <MaterialButton sx={{ m: 2 }} variant="gradient" color="dark">
                Submit
              </MaterialButton>
              <MaterialButton sx={{ m: 2 }} variant="gradient" color="dark">
                Cancel
              </MaterialButton>
            </MaterialBox>
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default Convertsalesorder;
